module.exports = __webpack_public_path__ + "img/tunein-podcasts.eb9ed4d8.png";